import { render, staticRenderFns } from "./PaySuccessShorex.vue?vue&type=template&id=49b903a5&scoped=true"
import script from "./PaySuccessShorex.vue?vue&type=script&lang=js"
export * from "./PaySuccessShorex.vue?vue&type=script&lang=js"
import style0 from "./PaySuccessShorex.vue?vue&type=style&index=0&id=49b903a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b903a5",
  null
  
)

export default component.exports